import { connect } from 'react-redux';
import { AppState } from '../../../../../types/store';
import {
  actions as streamActions,
  selectors as streamSelectors,
  withOffset as streamWithOffset,
} from '@wix/da-shared-react/pkg/Stream';
import { getFolderById } from '../../../../selectors/folders';
import {
  DEVIATIONS_PER_FETCH_COUNT,
  FOLDER_DEVIATIONS_STREAM_GROUP_ID,
  STREAM_PARAM_TYPE_FETCHING_PAUSED,
  getFolderDeviationsStreamId,
  getFolderDeviationsStreamParams,
} from '../../../../streams/folderDeviations';
import { getDeviationsByIds } from '@wix/da-shared-react/pkg/redux/deviations/selectors';
import DeviationsSection, { Props } from './FolderContent';
import { isCurrentUserProfileOwner } from '../../../../selectors/users';
import {
  getGallectionSectionType,
  getSelectedFolderId,
  getSortOrder,
  getSelectedSubfolder,
} from '../../../../selectors/gallectionSection';

export default connect((state: AppState, { folderId }) => {
  const gallectionType = getGallectionSectionType(state);
  const sortOrder = getSortOrder(state);

  let streamId = getFolderDeviationsStreamId(
    gallectionType,
    folderId,
    sortOrder
  );
  const selectedSubfolder = getSelectedSubfolder(state);
  if (selectedSubfolder && selectedSubfolder.parentId === folderId) {
    streamId = getFolderDeviationsStreamId(
      gallectionType,
      selectedSubfolder.folderId,
      sortOrder
    );
    return {
      streamId,
      gallectionType,
      sortOrder,
      subfolder: selectedSubfolder,
      subfolderId: selectedSubfolder.folderId,
    };
  }
  return { streamId, gallectionType, sortOrder };
})(
  connect(
    (state: AppState, { streamId, folderId, gallectionType }) => {
      const folder = getFolderById(state, gallectionType, folderId);
      return {
        streamId,
        folder,
        isSelected: getSelectedFolderId(state) === folderId,
        deviations: getDeviationsByIds(
          state,
          streamSelectors.getItems(state, streamId) || []
        ),
        isOwner: isCurrentUserProfileOwner(state),
        gallectionType: getGallectionSectionType(state),
        isInitialized: streamSelectors.isInitialized(state, streamId),
        hasMore: streamSelectors.hasMore(state, streamId) !== false,
        isFetching: streamSelectors.isFetching(state, streamId),
        isFetchingPaused: streamSelectors.getStreamParam(
          state,
          streamId,
          STREAM_PARAM_TYPE_FETCHING_PAUSED
        ),
      };
    },
    (dispatch, { streamId, gallectionType, folderId, subfolderId }: Props) => {
      return {
        initFetch: () => {
          dispatch(
            streamWithOffset.actions.initialize({
              streamId,
              streamParams: getFolderDeviationsStreamParams(
                gallectionType,
                subfolderId || folderId
              ),
              hasMore: true,
              groupId: FOLDER_DEVIATIONS_STREAM_GROUP_ID,
              itemsPerFetch: DEVIATIONS_PER_FETCH_COUNT,
            })
          );
          dispatch(streamWithOffset.actions.fetch(streamId));
        },
        fetchMore: () => dispatch(streamWithOffset.actions.fetch(streamId)),
        setFetchingPausedFlag: value =>
          dispatch(
            streamActions.setParam({
              streamId,
              paramType: STREAM_PARAM_TYPE_FETCHING_PAUSED,
              paramValue: value,
            })
          ),
      };
    }
  )(DeviationsSection)
);
